import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { store } from "store/index";
import API from "api.js";
import { setToken, setUser, setSub, expVidPopup } from "action/index.js";
import useLogOut from "hooks/useLogOut";
import ConfirmLogoutModal from "./ConfirmLogoutModal";
import { isWhiteLabel } from "utils/whiteLabel";

export default function Logout(props) {
  const { logout } = useLogOut();
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const logoutHandler = () => {
    toggleModal();
  };

  return (
    <>
      <a href="javascript:void(0);" onClick={logoutHandler}>
        {/* <span className={`menuIcon ${props.icon}`}></span> */}
       <img src={`${props.icon}`} className={!isWhiteLabel() ? "non-wl-inactive" : ""} ></img>
        <span
          className={`Notifications menuText ${
            props.premiumIcon ? "crownIcon" : ""
          } ${!isWhiteLabel() ? "non-wl-inactive" : ""}`}
          
          style={{color: modalOpen ? (isWhiteLabel() ? "#ffff" : "#10101") : "#acacad"}}
        >
          {props.label}
        </span>
      </a>
      <ConfirmLogoutModal
        isOpen={modalOpen}
        onConfirm={logout}
        toggle={toggleModal}
      />
    </>
  );
}
